import React from "react";
import { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import List from "@material-ui/core/List";
import { Tooltip } from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import { ApiDelete, ApiGet, ApiPost, ApiPut, } from "../../../helpers/API/ApiData";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast, ToastContainer } from "react-toastify";
import DataTable, { defaultThemes } from "react-data-table-component";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import AddCtegoryIcon from "../../_assets/plugins/keenthemes-icons/svg/buttonImg.png";
import CategoryIcon from "../../_assets/plugins/keenthemes-icons/svg/Prize.png";
import CTGYIcon from "../../_assets/plugins/keenthemes-icons/svg/ctgyicon.png";

export default function Category() {
  const [packageData, setPackageData] = useState({});
  const [addPackage, setAddPackage] = useState(false);
  const [errors, setErrors] = useState({});
  const [getAllPackage, setGetAllPackage] = useState({});
  const [isEditApi, setIsEditApi] = useState(false);
  const [search, setSearch] = useState();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [packageIdForEdit, setPackageIdForEdit] = useState();
  const [packageIdForDelete, setPackageIdForDelete] = useState();
  const [countPerPage, setCountPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [loaderForGetAll, setLoaderForGetAll] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    getAllPackageData();
  }, [page, countPerPage]);

  const addPackageModelClose = (e) => {
    setAddPackage(false);
    setIsEditApi(false);
    setErrors(false);
    setPackageData({});
  };
  const onhandleChange = (e) => {
    e.target.value.replace(/[^a-zA-Z]/g, "");
    const { name, value } = e.target;
    setPackageData({ ...packageData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const formValidation = () => {
    let formvalied = true;
    let errors = {};
    if (!packageData?.name?.trim() || packageData?.name === "") {
      formvalied = false;
      errors["name"] = "*Please enter Name.";
    }
    setErrors(errors);
    return formvalied;
  };

  const handleClose = () => {
    setShow(false);
  };

  const getAllPackageData = async () => {
    setLoaderForGetAll(true);
    if (!search) {
      await ApiGet(`category/find?page=${page}&limit=${countPerPage}&days=30`)
        .then((res) => {
          setGetAllPackage(res?.data?.payload);
          setCount(res?.data?.count);
          setLoaderForGetAll(false);
        })
        .catch((err) => {
          setLoaderForGetAll(false);
        });
    } else {
      await ApiGet(
        `category/find?letter=${search}&page=${page}&limit=${countPerPage}&days=30`
      )
        .then((res) => {
          setGetAllPackage(res?.data?.payload);
          setCount(res?.data?.count);
          setLoaderForGetAll(false);
        })
        .catch((err) => {
          setLoaderForGetAll(false);
        });
    }
  };

  const addPackageData = async (e) => {
    setIsEditApi(false);
    if (formValidation()) {
      setLoader(true);
      let data = {
        name: packageData?.name,
      };

      await ApiPost(`category/create`, data)
        .then((res) => {
          toast.success("Category add successfully");
          setAddPackage(false);
          setIsEditApi(false);
          getAllPackageData();
          setPackageData({});
          setLoader(false);
        })
        .catch((err) => {
          toast.error(err?.response?.statusText);
          setLoader(false);
        });
    }
  };

  const editPackageData = async (e) => {
    if (formValidation()) {
      let data = {
        name: packageData?.name,
      };

      setLoader(true);

      await ApiPut(`category/update?id=${packageIdForEdit}`, data)
        .then((res) => {
          toast.success("Category update successfully");
          getAllPackageData();
          setAddPackage(false);
          setIsEditApi(false);
          setPackageData([]);
          setLoader(false);
        })
        .catch((err) => {
          toast.error(err?.response?.statusText);
          setLoader(false);
        });
    }
  };

  const deletePackageData = async () => {
    await ApiDelete(`category/delete?id=${packageIdForDelete}`)
      .then((res) => {
        if (res?.status === 200) {
          toast.success("Category  delete successfully");
          setShow(false);
          getAllPackageData();
        } else {
          toast.error("something went wrong please try again");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.statusText);
      });
  };

  const handleSearch = (e) => {
    let val = e.target.value.replace(/[^\w\s]/gi, "");
    setSearch(val);
  };
  const debouncedSearchTerm = useDebounce(search, 500);
  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }

  useEffect(() => {
    if (debouncedSearchTerm) {
      setPage(1);
      setCount(0);
      setCountPerPage(countPerPage);
      getAllPackageData();
    } else {
      setPage(1);
      setCount(0);
      setCountPerPage(countPerPage);
      getAllPackageData();
    }
  }, [debouncedSearchTerm]);

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };

  const columns = [
    {
      name: "SNr.",
      selector: (row, index) => (page - 1) * countPerPage + (index + 1),
      width: "5%",
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,

    },
    {
      name: "Edit",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between mr-3">
              <div
                className="cursor-pointer pl-2"
                onClick={(e) => {
                  setIsEditApi(true);
                  setAddPackage(true);
                  setPackageIdForEdit(row?._id);
                  setPackageData({
                    name: row?.name,
                  });
                }}
              >
                <Tooltip title="edit blog" arrow>
                  <button style={{
                    background: "#002a5a", color: "white", borderRadius: "20px",
                    border: "2px solid #939393",
                    padding: "5px 10px",
                    whiteSpace: "nowrap"
                  
                  }} onClick={(e) => {
                    setIsEditApi(true);
                    setAddPackage(true);
                    setPackageIdForEdit(row?._id);
                    setPackageData({
                      name: row?.name,
                    });
                  }}>Manage</button>
                </Tooltip>
              </div>

              {/* <div
                data-toggle="modal"
                data-target="#exampleModal"
                className="cursor-pointer"
                onClick={(e) => {
                  setPackageIdForDelete(row?._id);
                  setShow(true);
                }}
              >
                <Tooltip title="delete blog" arrow>
                  <DeleteIcon />
                </Tooltip>
              </div> */}
            </div>
          </>
        );
      },
      width: "10%",
    },
    {
      name: "Delete",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between mr-3">
              {/* <div
                className="cursor-pointer pl-2"
                onClick={(e) => {
                  setIsEditApi(true);
                  setAddPackage(true);
                  setPackageIdForEdit(row?._id);
                  setPackageData({
                    name: row?.name,
                  });
                }}
              >
                <Tooltip title="edit blog" arrow>
                  <button style={{ background: "#002a5a", color: "white", borderRadius: "20px" }} onClick={(e) => {
                    setIsEditApi(true);
                    setAddPackage(true);
                    setPackageIdForEdit(row?._id);
                    setPackageData({
                      name: row?.name,
                    });
                  }}>Manage</button>
                </Tooltip>
              </div> */}

              <div
                data-toggle="modal"
                data-target="#exampleModal"
                className="cursor-pointer"
                onClick={(e) => {
                  setPackageIdForDelete(row?._id);
                  setShow(true);
                }}
              >
                <Tooltip title="delete blog" arrow>
                  <button
                    style={{
                      background: "#ff0000",
                      color: "white",
                      borderRadius: "20px",
                      border: "2px solid #939393",
                      padding: "5px 10px"
                    }}>
                    Delete
                  </button>
                </Tooltip>
              </div>
            </div>
          </>
        );
      },
      width: "10%",
    },
  ];

  return (
    <>
      <div className="card">
        <ToastContainer />
        <div className="heading-banner d-flex justify-content-center">
          <div className="align-items-center d-flex">
            <img src={CategoryIcon} alt="CategoryIcon" className="exchangeImg" />
            {/* <div className="client-details pl-2">
              <h1 className="text-white">{count}</h1>
              <h6 className="text-white">All Categorys</h6>
            </div> */}
          </div>
        </div>
        <div className="p-2 mb-2 pt-10">
          <div className="row mb-4 pr-3  justify-content-between align-items-center">
            <div className="d-flex justify-content-between">
              {/* <h2 className="pl-3 pt-2">Categorys</h2> */}
            </div>
            <div className="cus-medium-button-style button-height  button-details-alignment">
              <button
                className="btncenter"
                onClick={() => {
                  setAddPackage(true);
                }}
              >
                <img src={AddCtegoryIcon} alt={AddCtegoryIcon} />
                <img src={CTGYIcon} alt="CTGYIcon" />
                Add CTGY
              </button>
            </div>
            <div className="">
              <div>
                <input
                  type="text"
                  className={`form-control rounded-lg custom-style`}
                  name="search"
                  value={search}
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search"
                />
              </div>
            </div>
          </div>
        </div>
        {loaderForGetAll ? (
          <div className="text-center">
            <div className="spinner-border"></div>
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={getAllPackage}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[10, 20, 25, 50, 100]}
            paginationDefaultPage={page}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
          />
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Alert!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this Category?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="danger" onClick={() => deletePackageData()}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addPackage === true ? (
        <Dialog fullScreen open={addPackage}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={(e) => addPackageModelClose(e)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <List>
            <div className="heading-banner d-flex justify-content-center">
              <div className="align-items-center d-flex">
                <img src={CategoryIcon} alt="CategoryIcon" className="exchangeImg" />
                <div className="client-details pl-2">
                  <h6 className="text-white child-heading">Categorys</h6>
                </div>
              </div>
            </div>
            <div className="m-auto w-1000px pt-10">
              <div className="form-group row">
                <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Name</label>
                <div className="col-lg-7 col-xl-7">
                  <div>
                    <input
                      type="text"
                      className={`form-control rounded-lg custom-style`}
                      id="title"
                      name="name"
                      value={packageData?.name}
                      onChange={(e) => {
                        onhandleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["name"]}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              {loader ? (
                <>
                  <div className="text-center  button-details-alignment">
                    <button className="btn" type="button">
                      <img src={AddCtegoryIcon} alt={AddCtegoryIcon} />
                      <img src={CTGYIcon} alt="CTGYIcon" className="prizeCategory-child-img" />
                      {isEditApi ? "Edit  CTGY" : "Add CTGY"}
                      <span
                        className="mx-3 spinner spinner-black"
                        role="status"
                      ></span>
                    </button>
                  </div>
                </>
              ) : (
                <div className=" button-details-alignment">
                  <button
                    className="btn center"
                    onClick={(e) => {
                      isEditApi ? editPackageData(e) : addPackageData(e);
                    }}
                  >
                    <img src={AddCtegoryIcon} alt={AddCtegoryIcon} />
                    <img src={CTGYIcon} alt="CTGYIcon" className="prizeCategory-child-img" />
                    {isEditApi ? "Edit CTGY" : "Add CTGY"}
                  </button>
                </div>
              )}
            </div>
          </List>
        </Dialog >
      ) : null
      }
    </>
  );
}
